import React from 'react';
import { FounderCard, type Founder } from './FounderCard';
import foundersData from '../data/founders.json';

export function FoundersBand() {
  const founders = foundersData as Founder[];
  return (
    <section className="founders-band" aria-label="Founders and senior leadership">
      <div className="founders-band__grid">
        {founders.map((f) => (
          <FounderCard key={f.id} founder={f} />
        ))}
      </div>
    </section>
  );
}
